import React from 'react';

import Page from './Page';

const Pages = (props) => {
  const { currentPage, totalPages, onChange } = props;

  const paginationPages = getPaginationArray(currentPage, totalPages);

  return paginationPages.map((paginationPage) => (
    <Page
      key={paginationPage}
      page={paginationPage}
      isCurrent={currentPage === paginationPage}
      onChange={onChange}
    />
  ));
};

const getPaginationArray = (page, maxPage) => {
  if (page === 1) {
    return [1, 2, 3].filter((p) => p <= maxPage);
  }

  return [page - 1, page, page + 1].filter((p) => p <= maxPage);
};

export default Pages;
